/**
 * 
 * @param {Date} createdAt 報酬発生日
 * @returns 
 */
export const rewardAmount = (createdAt) => {
    const baseDate = new Date("2023-11-30T15:00:00Z"); // tz考慮
    const amount = createdAt > baseDate ? 3000 : 10000;
    return amount;
}